// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Slider_sliderContainer__CNg9p"};